var map = {
	"./bg-book-launch-untold-tales-of-old-british-columbia.png": 811,
	"./bg-canyon-of-cultures-festival.png": 359,
	"./bg-card-desktop-book-launch-untold-tales-of-old-british-columbia.png": 279,
	"./bg-card-desktop-canyon-of-cultures-festival.png": 923,
	"./bg-card-desktop-strawberry-social.png": 193,
	"./bg-card-mobile-book-launch-untold-tales-of-old-british-columbia.png": 525,
	"./bg-card-mobile-canyon-of-cultures-festival.png": 629,
	"./bg-card-mobile-strawberry-social.png": 743,
	"./bg-strawberry-social.png": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 557;